import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingRequestTypeServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestTypeServices";

const UpdateStudyUnblindingRequestType = ({
  requestTypeData,
  getEIWRSUnblindingRequestTypeData,
  Show,
  Hide,
  Title,
  setRequestId,
}) => {
  const { studyId } = useParams()
  const [requestType, setRequestType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSUnblindingRequestTypeData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Unblinding Request Type!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = requestTypeData?._id;
        userData.studyId = studyId;
        userData.requestType = requestType;
        let data = await eiwrsUnblindingRequestTypeServices.updateEIWRSUnblindingRequestTypeData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingRequestTypeData();
          Hide();
          setRequestId("");
          setRequestType("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setRequestType(requestTypeData?.requestType);
  }, [requestTypeData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Request Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setRequestType(e.target.value)}
              value={requestType}
              className="br3"
              placeholder="Enter Request Type"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!requestType || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSUnblindingRequestTypeData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Request Type"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyUnblindingRequestType;
